import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import { READER_SET_THEME, READER_SET_FONT_SIZE } from "./actions";

export const THEME_HIGH = "theme/BRIGHTNESS_HIGH";
export const THEME_MEDIUM = "theme/BRIGHTNESS_MEDIUM";
export const THEME_LOW = "theme/BRIGHTNESS_LOW";

export const THEME_FONT_SIZE_SMALL = "reader/fontSizeSmall";
export const THEME_FONT_SIZE_MEDIUM = "reader/fontSizeMedium";
export const THEME_FONT_SIZE_LARGE = "reader/fontSizeLarge";

interface Reader {
    theme: string;
    size: string;
}
type ReaderAction = Action<Reader>;

const initialState: Reader = {
    theme: THEME_MEDIUM,
    size: THEME_FONT_SIZE_SMALL,
};

const fnMap = {
    [READER_SET_THEME]: (s: ReducerState, a: ReaderAction) =>
        s.set("theme", a.payload),
    [READER_SET_FONT_SIZE]: (s: ReducerState, a: ReaderAction) =>
        s.set("size", a.payload),
};

export const readerReducer = reducerFn("reader", initialState, fnMap);
